var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 7.03125C6.50658 7.03125 7.03125 6.50658 7.03125 5.85938C7.03125 5.21217 6.50658 4.6875 5.85938 4.6875C5.21217 4.6875 4.6875 5.21217 4.6875 5.85938C4.6875 6.50658 5.21217 7.03125 5.85938 7.03125Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.03125C13.1472 7.03125 13.6719 6.50658 13.6719 5.85938C13.6719 5.21217 13.1472 4.6875 12.5 4.6875C11.8528 4.6875 11.3281 5.21217 11.3281 5.85938C11.3281 6.50658 11.8528 7.03125 12.5 7.03125Z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 7.03125C19.7878 7.03125 20.3125 6.50658 20.3125 5.85938C20.3125 5.21217 19.7878 4.6875 19.1406 4.6875C18.4934 4.6875 17.9688 5.21217 17.9688 5.85938C17.9688 6.50658 18.4934 7.03125 19.1406 7.03125Z",
    fill: "#8B8B8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 13.6719C6.50658 13.6719 7.03125 13.1472 7.03125 12.5C7.03125 11.8528 6.50658 11.3281 5.85938 11.3281C5.21217 11.3281 4.6875 11.8528 4.6875 12.5C4.6875 13.1472 5.21217 13.6719 5.85938 13.6719Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.6719C13.1472 13.6719 13.6719 13.1472 13.6719 12.5C13.6719 11.8528 13.1472 11.3281 12.5 11.3281C11.8528 11.3281 11.3281 11.8528 11.3281 12.5C11.3281 13.1472 11.8528 13.6719 12.5 13.6719Z",
    fill: "#8B8B8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 13.6719C19.7878 13.6719 20.3125 13.1472 20.3125 12.5C20.3125 11.8528 19.7878 11.3281 19.1406 11.3281C18.4934 11.3281 17.9688 11.8528 17.9688 12.5C17.9688 13.1472 18.4934 13.6719 19.1406 13.6719Z",
    fill: "#8B8B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 20.3125C6.50658 20.3125 7.03125 19.7878 7.03125 19.1406C7.03125 18.4934 6.50658 17.9688 5.85938 17.9688C5.21217 17.9688 4.6875 18.4934 4.6875 19.1406C4.6875 19.7878 5.21217 20.3125 5.85938 20.3125Z",
    fill: "#8B8B8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.3125C13.1472 20.3125 13.6719 19.7878 13.6719 19.1406C13.6719 18.4934 13.1472 17.9688 12.5 17.9688C11.8528 17.9688 11.3281 18.4934 11.3281 19.1406C11.3281 19.7878 11.8528 20.3125 12.5 20.3125Z",
    fill: "#8B8B8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 20.3125C19.7878 20.3125 20.3125 19.7878 20.3125 19.1406C20.3125 18.4934 19.7878 17.9688 19.1406 17.9688C18.4934 17.9688 17.9688 18.4934 17.9688 19.1406C17.9688 19.7878 18.4934 20.3125 19.1406 20.3125Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.093c45816288cd65a1fcd0b4fe470160.svg";
export { ForwardRef as ReactComponent };